import CityPageTemplate from "../city-template/CityPageTemplate";
import { escondidoConfig } from "./data";

export default function EscondidoPage() {
  return <CityPageTemplate config={escondidoConfig} />;
}